export default __webpack_public_path__ + "static/media/10.10bc0017.jpeg";